import { render, staticRenderFns } from "./IntegratedAuthentication.vue?vue&type=template&id=4fbd2e4b&scoped=true"
import script from "./IntegratedAuthentication.vue?vue&type=script&lang=js"
export * from "./IntegratedAuthentication.vue?vue&type=script&lang=js"
import style0 from "@/vendor/styles/pages/authentication.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "@/vendor/libs/vue-notification/vue-notification.scss?vue&type=style&index=1&prod&lang=scss&external"
import style2 from "./IntegratedAuthentication.vue?vue&type=style&index=2&id=4fbd2e4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbd2e4b",
  null
  
)

export default component.exports